// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"FO-z","categoryName":"GO-z","categoryNameSearchHeader":"HO-z","categoryContent":"IO-z","bottomAligned":"JO-z","image":"KO-z","imageNoBackground":"LO-z"};